import React from 'react';

import {REMOTE_CONFIG_PATHS} from '../../../constants/remoteConfigPaths';
import {DynamicContent} from '../../DynamicContent';

export const InitialTextPrivacyPolicy = () => (
  <DynamicContent
    configPath={REMOTE_CONFIG_PATHS.PRIVACY_POLICY.INITIAL_TEXT}
    renderAsHtml={true}
  />
);
